export const staffingCompanyGroups = state => state.getIn(['staffingCompanyGroups', 'entities']);
export const staffingCompanyGroupById = (state, id) => staffingCompanyGroups(state).get(String(id));
export const staffingCompanyGroupsByIds = (state, ids) =>
  ids.map(id => staffingCompanyGroupById(state, id));
